import React from "react";
import { CartContainerDesktop } from "./CartContainerDesktop.jsx";
import { CartContainerMobile } from "./CartContainerMobile.jsx";
const CartContainer = ({ versionDesktop = 1 }) => {
  return (
    <>{versionDesktop ? <CartContainerDesktop /> : <CartContainerMobile />}</>
  );
};

export default CartContainer;
